import {
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatSelect } from "@angular/material/select";
import { Store } from "@ngrx/store";
import {
  EmployeeService,
  EntityContainerModel,
  EntityLabelLinkService,
  EntityService,
  Pagination,
  // EntityLoginSubjectLinkContainerModel,
  // EntityLoginSubjectLinkService,
  // ApiResponseModel
} from "blg-akaun-ts-lib";
import { SessionSelectors } from "../../modules/session/session-controller/selectors";
import { SessionStates } from "../../modules/session/session-controller/states";
import { ReplaySubject } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged
} from "rxjs/operators";
import { SubSink } from "subsink2";
import { AppConfig } from "../../visa";

@Component({
  selector: "app-sales-man",
  templateUrl: "./sales-man.component.html",
  styleUrls: ["./sales-man.component.css"],
})
export class SalesManComponent implements OnInit, OnDestroy  {
  @Input() salesAgent: FormControl;
  @Input() isPurchaser: boolean;
  @Input() isTechniqian: boolean = false; // by default, the value will be false.
  @Input() labels: any;
  @Input() required: boolean = false;

  @Output() salesAgentChange = new EventEmitter<FormControl>();
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  pagination = new Pagination();
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<EntityContainerModel[]> = new ReplaySubject<
    EntityContainerModel[]
  >(1);
  entityList: any = [];
  //EntityLabelLinkContainerModel
  fieldLabel: string;
  @ViewChild("matSelect") matSelectInput: MatSelect;

  // subjectGuid = localStorage.getItem('guid');

  constructor(
    private employeeService: EmployeeService,
    private entityService: EntityService,
    // private entityLoginSubjectLinkService: EntityLoginSubjectLinkService,
    protected readonly sessionStore: Store<SessionStates>,
    private entityLabelLinkService: EntityLabelLinkService,
    private cdr: ChangeDetectorRef,
  ) {}

  masterSettings$ = this.sessionStore.select(
    SessionSelectors.selectMasterSettings
  );

  async ngOnInit() {
    this.fieldLabel = this.isPurchaser ? "Purchaser" : "Sales Agent";

    // Is to be used in Job sheet, by default the value is always false, so it will skip this by default. 
    // However, in Jobsheet applet, the 2 way  binding is as [isTechniqianLabel] = "true". Hence, it will make the label into Techniqian. 
    if (this.isTechniqian) {
      this.fieldLabel = "Techniqian"
    }

    // console.log("DEBUG2222::", this.subjectGuid);
    if (this.labels?.length > 0) {
      this.pagination.conditionalCriteria = [
        { columnName: "calcTotalRecords", operator: "=", value: "true" },
        { columnName: "namespace", operator: "=", value: "EMPLOYEE_CATEGORY" },
        { columnName: "label_hdr_guids", operator: "=", value: this.labels },
      ];
    } else {
      this.pagination.conditionalCriteria = [
        { columnName: "calcTotalRecords", operator: "=", value: "true" },
        { columnName: "namespace", operator: "=", value: "EMPLOYEE_CATEGORY" },
      ];
    }

    let entityHdrGuids: string[] = [];
    try {
      const response = await this.entityLabelLinkService
        .getByCriteria(this.pagination, this.apiVisa)
        .toPromise();

      entityHdrGuids = response.data
        .map((item) =>
          item.bl_fi_mst_entity_label_link.entity_hdr_guid?.toString()
        )
        .filter((guid) => !!guid);

      if (entityHdrGuids.length > 0) {
        const entityResponse = await this.entityService
          .getByCriteria(
            new Pagination(0, 1000, [
              {
                columnName: "hdr_guids",
                operator: "=",
                value: entityHdrGuids.toString(),
              },
              {
                columnName: "is_employee",
                operator: "=",
                value: "true",
              },
            ]),
            AppConfig.apiVisa
          )
          .toPromise();

        // // Retrieve entities and login entities
        this.entityList = entityResponse.data;
        this.filteredOptions$.next(this.entityList);
        // let paging1 = new Pagination();
        // paging1.conditionalCriteria = [
        //   { columnName: "subject_guid", operator: "=", value: this.subjectGuid },
        // ];
        // const loginEntities = [];
        // const rearrangedEntityList = [];

        // // Fetch login entities
        // this.subs.sink = this.entityLoginSubjectLinkService.getByCriteria(paging1, this.apiVisa).subscribe(
        //   (resp: ApiResponseModel<EntityLoginSubjectLinkContainerModel>) => {
        //     if (resp && resp.data) {
        //       resp.data.forEach(item => {
        //         if (item.bl_fi_mst_entity_login_subject_link && item.bl_fi_mst_entity_login_subject_link.entity_hdr_guid) {
        //           loginEntities.push(item.bl_fi_mst_entity_login_subject_link.entity_hdr_guid.toString());
        //         }
        //       });

        //       // Filter and rearrange entities
        //       this.entityList.forEach(entity => {
        //         if (entity && entity.bl_fi_mst_entity_hdr && entity.bl_fi_mst_entity_hdr.guid && loginEntities.includes(entity.bl_fi_mst_entity_hdr.guid)) {
        //           rearrangedEntityList.push(entity);
        //         }
        //       });
        //       this.entityList = rearrangedEntityList.concat(this.entityList.filter(entity => !rearrangedEntityList.includes(entity)));

        //       // Log and update
        //       // console.log("Rearranged entityList:", this.entityList);
        //       this.filteredOptions$.next(this.entityList);
        //     } else {
        //       this.filteredOptions$.next(this.entityList);
        //       console.error("Error: Invalid response or missing data.");
        //     }
        //   },
        //   (error) => {
        //     console.error("Error occurred while fetching data:", error);
        //   }
        // );

      }
    } catch (error) {
      // Handle errors here
      console.error(error);
    }

    this.subs.sink = this.filterControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe({ next: (resolve) => this.filterCurrency(resolve) });
    // this.filteredOptions$.subscribe(options => {
    //   if (options.length > 0) {
    //     this.salesAgent.setValue(options[0].bl_fi_mst_entity_hdr.guid); // Set the value of the FormControl
    //   }
    // });
  }

  filterCurrency(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter((c) => {
        const name = c.bl_fi_mst_entity_hdr?.name?.toLocaleLowerCase() || '';
        const employeeCode = c.bl_fi_mst_entity_hdr?.employee_code?.toLocaleLowerCase() || '';
        return name.includes(search) || employeeCode.includes(search);
      });
      this.filteredOptions$.next(filter);
    }
  }

  // ngDoCheck(): void {
  //   if (this.salesAgent.value === undefined || this.salesAgent.value === null) {
  //     setTimeout(() => {
  //       this.matSelectInput.focus();
  //       this.cdr.detectChanges();
  //     }, 500);
  //   }
  // }

  getLabel(): string {
    return this.required ? `${this.fieldLabel} *` : this.fieldLabel;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
